/* ==========================================================================
   Chimera Studio redesign — interactions for the chm-* sections.
   Safe by default: if this file fails, all content is still visible.
   Re-initialises when a section is edited in the Shopify theme editor.
   ========================================================================== */
(function () {
  if (window.__chm) return;
  window.__chm = true;

  var root = document.documentElement;
  var mq = function (q) { try { return window.matchMedia(q).matches; } catch (e) { return false; } };
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(pointer: fine)');
  var design = !!(window.Shopify && window.Shopify.designMode);
  var wide = window.matchMedia ? window.matchMedia('(min-width: 900px)') : { matches: true };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var each = function (sel, ctx, fn) { Array.prototype.forEach.call((ctx || document).querySelectorAll(sel), fn); };

  if (!reduce && !design) root.classList.add('chm-motion');

  /* ---------- smooth scroll (home page only; pauses while Ride drawers are open) ---------- */
  var lenis = null;
  if (!reduce && !design && document.body.classList.contains('chm-smooth') && window.Lenis) {
    try { lenis = new window.Lenis({ lerp: 0.09, smoothWheel: true }); } catch (e) { lenis = null; }
    if (lenis) {
      new MutationObserver(function () {
        var locked = document.body.classList.contains('overflow-hidden') || document.body.classList.contains('overflow-hidden-mobile') || document.body.classList.contains('overflow-hidden-tablet');
        if (locked) lenis.stop(); else lenis.start();
      }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a) return;
        var id = a.getAttribute('href').slice(1);
        var el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80, duration: 1.4 });
      });
    }
  }

  /* ---------- reveals ---------- */
  // A fully clipped (.chm-rw) box never counts as visible, so watch its parent instead.
  var io = null, pending = new Map();
  function watchTarget(el) { return el.classList.contains('chm-rw') && el.parentElement ? el.parentElement : el; }
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        (pending.get(en.target) || []).forEach(function (el) { el.classList.add('is-in'); });
        pending.delete(en.target); io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
  }
  function initReveals(ctx) {
    var vh = window.innerHeight;
    each('.chm-r, .chm-rw, .chm-word, .chm-bt--lg', ctx, function (el) {
      if (el.classList.contains('is-in')) return;
      var r = watchTarget(el).getBoundingClientRect();
      if (design || !io || (r.top < vh * 0.95 && r.bottom > 0)) { el.classList.add('is-in'); return; }
      var t = watchTarget(el);
      if (!pending.has(t)) { pending.set(t, []); io.observe(t); }
      pending.get(t).push(el);
    });
  }
  window.addEventListener('scroll', function () {
    var vh = window.innerHeight;
    pending.forEach(function (els, t) {
      var r = t.getBoundingClientRect();
      if (r.top < vh * 0.92 && r.bottom > 0) { els.forEach(function (el) { el.classList.add('is-in'); }); pending.delete(t); if (io) io.unobserve(t); }
    });
  }, { passive: true });

  /* ---------- fit giant type to its box ---------- */
  function fitText(el) {
    if (!el) return;
    el.style.fontSize = '';
    var parts = el.querySelectorAll('.chm-ln > span');
    var w = parts.length ? Math.max.apply(null, Array.prototype.map.call(parts, function (s) { return s.getBoundingClientRect().width; })) : el.scrollWidth;
    var avail = el.clientWidth;
    if (w > avail && avail > 0) el.style.fontSize = (parseFloat(getComputedStyle(el).fontSize) * avail / w * 0.97) + 'px';
  }
  function fitAll() { each('[data-chm-fit]', document, fitText); }
  window.addEventListener('resize', fitAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);

  /* ---------- hero hotspot ---------- */
  var heroes = [];
  function initHero(ctx) {
    each('[data-chm-hero]', ctx, function (sec) {
      var frame = sec.querySelector('.chm-hm-frame'), inner = sec.querySelector('.chm-hm-inner'), img = inner && inner.querySelector('img');
      var hot = sec.querySelector('.chm-hot'), card = sec.querySelector('.chm-hot-card');
      var h = { frame: frame, inner: inner };
      heroes.push(h);
      if (!hot || !card || !img) return;
      var hx = parseFloat(sec.getAttribute('data-hot-x')) / 100, hy = parseFloat(sec.getAttribute('data-hot-y')) / 100;
      function place() {
        var iw = img.naturalWidth || 1000, ih = img.naturalHeight || 1000;
        var W = frame.clientWidth, H = frame.clientHeight, s = Math.max(W / iw, H / ih);
        var x = (W - iw * s) * 0.5 + hx * iw * s, y = (H - ih * s) * 0.5 + hy * ih * s;
        hot.style.left = x + 'px'; hot.style.top = y + 'px';
        var cw = card.offsetWidth || 270, ch = card.offsetHeight || 110;
        /* the photo layer is zoomed 1.12x for the parallax, so keep the card inside the part that is actually visible */
        var mx = W * (1 - 1 / 1.12) / 2 + 16, my = H * 0.11 + 16;
        var cx = (x + 34 + cw > W - mx) ? x - 34 - cw : x + 34;
        card.style.left = clamp(cx, mx, Math.max(mx, W - cw - mx)) + 'px';
        card.style.top = clamp(y - ch / 2, my, Math.max(my, H - ch - my)) + 'px';
      }
      if (img.complete) place(); else img.addEventListener('load', place);
      window.addEventListener('resize', place);
      setTimeout(function () { if (window.innerWidth >= 700) { card.classList.add('is-shown'); hot.setAttribute('aria-expanded', 'true'); } }, reduce || design ? 0 : 1700);
      hot.addEventListener('click', function () {
        var on = !card.classList.contains('is-shown');
        card.classList.toggle('is-shown', on);
        hot.setAttribute('aria-expanded', String(on));
      });
    });
  }

  /* ---------- bento micro-animations ---------- */
  function initBento(ctx) {
    each('[data-chm-why]', ctx, function (sec) {
      if (reduce) return;
      var sws = sec.querySelectorAll('.chm-sws i'), out = sec.querySelector('[data-hex-out]'), si = 0;
      var tick = sec.querySelector('.chm-tick'), ti = 0, tn = tick ? tick.children.length : 0;
      if (sec.__chmTimer) clearInterval(sec.__chmTimer);
      sec.__chmTimer = setInterval(function () {
        if (sws.length) {
          si = (si + 1) % sws.length;
          for (var i = 0; i < sws.length; i++) sws[i].classList.toggle('is-on', i === si);
          if (out) out.textContent = sws[si].getAttribute('data-hex') || '';
        }
        if (tick && tn) { ti = (ti + 1) % tn; tick.style.transform = 'translateY(' + (-ti * 100 / tn).toFixed(4) + '%)'; }
      }, 1800);
    });
  }

  /* ---------- spotlight ---------- */
  var spots = [];
  function initSpot(ctx) {
    each('[data-chm-spot]', ctx, function (el) {
      var sp = { el: el, x: .5, y: .5, tx: .5, ty: .5, hover: false };
      el.addEventListener('pointermove', function (e) { var r = el.getBoundingClientRect(); sp.tx = (e.clientX - r.left) / r.width; sp.ty = (e.clientY - r.top) / r.height; sp.hover = true; });
      el.addEventListener('pointerleave', function () { sp.hover = false; });
      spots.push(sp);
    });
  }

  /* ---------- pinned process ---------- */
  var pins = [];
  function initPin(ctx) {
    each('[data-chm-pin]', ctx, function (el) {
      pins.push({ el: el, steps: el.querySelectorAll('.chm-step'), pms: el.querySelectorAll('.chm-pm'), bar: el.querySelector('.chm-pin-bar span'), label: el.querySelector('.chm-pm-label'), cur: -1 });
    });
  }

  /* ---------- category hover photo ---------- */
  var cf = { el: null, img: null, x: 0, y: 0, tx: 0, ty: 0, rot: 0 };
  function initCats(ctx) {
    if (!fine || reduce) return;
    each('[data-chm-cats]', ctx, function (sec) {
      var fl = sec.querySelector('.chm-cat-float'); if (!fl) return;
      cf.el = fl; cf.img = fl.querySelector('img');
      each('.chm-cats a', sec, function (a) {
        a.addEventListener('pointerenter', function () {
          var src = a.getAttribute('data-img');
          if (!src) return;
          cf.img.src = src; fl.classList.add('is-shown');
        });
        a.addEventListener('pointerleave', function () { fl.classList.remove('is-shown'); });
      });
    });
  }

  /* ---------- cursor, magnetic buttons, card sheen (desktop mouse only, inside .chm) ---------- */
  var dot = null, ring = null, ringLabel = null, cur = { x: -100, y: -100, tx: -100, ty: -100 };
  function initCursor() {
    if (!fine || reduce || design || dot) return;
    dot = document.createElement('div'); dot.className = 'chm-cur-dot'; dot.setAttribute('aria-hidden', 'true');
    ring = document.createElement('div'); ring.className = 'chm-cur-ring'; ring.setAttribute('aria-hidden', 'true');
    ringLabel = document.createElement('b'); ring.appendChild(ringLabel);
    document.body.appendChild(dot); document.body.appendChild(ring);
    root.classList.add('chm-has-cursor');
    window.addEventListener('pointermove', function (e) {
      cur.tx = e.clientX; cur.ty = e.clientY; cf.tx = e.clientX; cf.ty = e.clientY;
      dot.style.transform = 'translate3d(' + e.clientX + 'px,' + e.clientY + 'px,0)';
      var t = e.target, ok = !!(t && t.closest);
      var inside = ok && !!t.closest('.chm');
      root.classList.toggle('chm-cur-on', inside);
      if (!inside) return;
      var lab = t.closest('[data-cursor]');
      var link = t.closest('a, button, label, select');
      var field = t.closest('input, textarea');
      var dk = !!(t.closest('.chm-dark') || t.closest('.chm-bt--dark'));
      ring.classList.toggle('is-lab', !!lab && !field);
      ring.classList.toggle('is-link', !lab && !!link && !field);
      dot.classList.toggle('is-hide', !!lab || !!field);
      ring.style.opacity = field ? '0' : '';
      ringLabel.textContent = lab ? lab.getAttribute('data-cursor') : '';
      dot.classList.toggle('is-dk', dk); ring.classList.toggle('is-dk', dk);
    });
    document.addEventListener('pointerleave', function () { root.classList.remove('chm-cur-on'); });
    window.addEventListener('pointerdown', function () { ring.classList.add('is-press'); });
    window.addEventListener('pointerup', function () { ring.classList.remove('is-press'); });
  }
  function initHover(ctx) {
    if (!fine || reduce) return;
    each('.chm-mag', ctx, function (m) {
      m.addEventListener('pointermove', function (e) {
        var r = m.getBoundingClientRect();
        m.style.transform = 'translate(' + ((e.clientX - (r.left + r.width / 2)) * 0.22).toFixed(1) + 'px,' + ((e.clientY - (r.top + r.height / 2)) * 0.32).toFixed(1) + 'px)';
      });
      m.addEventListener('pointerleave', function () { m.style.transform = ''; });
    });
    each('.chm-card', ctx, function (c) {
      var media = c.querySelector('.chm-card-media'); if (!media) return;
      c.addEventListener('pointermove', function (e) { var r = media.getBoundingClientRect(); media.style.setProperty('--mx', (e.clientX - r.left) + 'px'); media.style.setProperty('--my', (e.clientY - r.top) + 'px'); });
    });
  }

  /* ---------- progress line ---------- */
  var progress = null;
  function initProgress() {
    if (progress || !document.querySelector('.chm')) return;
    progress = document.createElement('div'); progress.className = 'chm-progress'; progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);
  }

  /* ---------- one shared frame loop ---------- */
  var lastY = window.scrollY, skew = 0, t0 = performance.now();
  function loop(now) {
    if (lenis) lenis.raf(now);
    var y = window.scrollY, vh = window.innerHeight, v = y - lastY;
    if (progress) progress.style.transform = 'scaleX(' + clamp(y / Math.max(1, document.documentElement.scrollHeight - vh), 0, 1).toFixed(4) + ')';

    if (!reduce) {
      heroes.forEach(function (h) {
        if (!h.frame || !h.inner) return;
        var fr = h.frame.getBoundingClientRect();
        if (fr.bottom > 0 && fr.top < vh) {
          var p = clamp((vh - fr.top) / (vh + fr.height), 0, 1), sc = 1.12, maxT = fr.height * (sc - 1) / 2 * 0.9;
          h.inner.style.transform = 'translateY(' + ((p - .5) * -2 * maxT).toFixed(1) + 'px) scale(' + sc + ')';
        }
      });
      skew = lerp(skew, clamp(v * -0.35, -9, 9), 0.12);
      each('.chm-mq-skew', document, function (m) { m.style.setProperty('--sk', skew.toFixed(2) + 'deg'); });
    }

    pins.forEach(function (pn) {
      if (wide.matches) {
        var pr = pn.el.getBoundingClientRect(), total = Math.max(1, pn.el.offsetHeight - vh);
        var pp = clamp(-pr.top / total, 0, 1), n = pn.pms.length || 1;
        if (pn.bar) pn.bar.style.width = (pp * 100).toFixed(1) + '%';
        for (var i = 1; i < pn.pms.length; i++) {
          var w = clamp((pp - (i / n - 0.1)) / 0.2, 0, 1);
          pn.pms[i].style.clipPath = 'inset(0 0 0 ' + ((1 - w) * 100).toFixed(2) + '%)';
          var im = pn.pms[i].querySelector('img'); if (im && !reduce) im.style.transform = 'scale(' + (1.15 - w * 0.15).toFixed(4) + ')';
        }
        var s = Math.min(n - 1, Math.floor(pp * n + 0.0001));
        if (s !== pn.cur) {
          pn.cur = s;
          for (var j = 0; j < pn.steps.length; j++) pn.steps[j].classList.toggle('is-on', j === s);
          if (pn.label && pn.steps[s]) pn.label.textContent = (pn.steps[s].getAttribute('data-label') || '');
        }
      } else if (pn.cur !== 99) {
        pn.cur = 99;
        for (var k = 0; k < pn.pms.length; k++) { pn.pms[k].style.clipPath = ''; var mk = pn.pms[k].querySelector('img'); if (mk) mk.style.transform = ''; }
      }
    });

    if (dot) {
      cur.x = lerp(cur.x, cur.tx, 0.16); cur.y = lerp(cur.y, cur.ty, 0.16);
      ring.style.transform = 'translate3d(' + cur.x.toFixed(1) + 'px,' + cur.y.toFixed(1) + 'px,0)';
    }
    if (cf.el) {
      var dx = cf.tx - cf.x;
      cf.x = lerp(cf.x, cf.tx, 0.12); cf.y = lerp(cf.y, cf.ty, 0.12);
      cf.rot = lerp(cf.rot, clamp(dx * 0.08, -12, 12), 0.1);
      cf.el.style.transform = 'translate3d(' + (cf.x + 40).toFixed(1) + 'px,' + (cf.y - 180).toFixed(1) + 'px,0) rotate(' + cf.rot.toFixed(2) + 'deg)';
    }

    var tt = (now - t0) / 1000;
    spots.forEach(function (sp) {
      if (!document.body.contains(sp.el)) return;
      if (!sp.hover) { sp.tx = reduce ? .5 : .5 + Math.sin(tt * 0.45) * 0.26; sp.ty = reduce ? .5 : .5 + Math.sin(tt * 0.7 + 1) * 0.22; }
      sp.x = lerp(sp.x, sp.tx, sp.hover ? 0.18 : 0.05); sp.y = lerp(sp.y, sp.ty, sp.hover ? 0.18 : 0.05);
      sp.el.style.setProperty('--x', (sp.x * 100).toFixed(2) + '%');
      sp.el.style.setProperty('--y', (sp.y * 100).toFixed(2) + '%');
      sp.el.style.setProperty('--r', Math.round(sp.el.clientWidth * 0.3) + 'px');
    });

    lastY = y;
    requestAnimationFrame(loop);
  }

  /* ---------- shop rows: arrow buttons for the one-line category rows ---------- */
  function initRows(ctx) {
    each('[data-chm-rowwrap]', ctx, function (w) {
      if (w.__chmRow) return; w.__chmRow = true;
      var row = w.querySelector('[data-chm-row]'), prev = w.querySelector('[data-chm-prev]'), next = w.querySelector('[data-chm-next]');
      if (!row) return;
      function update() {
        var max = row.scrollWidth - row.clientWidth - 2;
        if (prev) prev.disabled = row.scrollLeft <= 2;
        if (next) next.disabled = row.scrollLeft >= max;
        w.classList.toggle('chm-row-fits', max <= 0);
      }
      function go(dir) { row.scrollBy({ left: dir * row.clientWidth * 0.85, behavior: reduce ? 'auto' : 'smooth' }); }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update(); setTimeout(update, 600);
    });
  }

  /* ---------- boot + theme editor support ---------- */
  function initAll(ctx) {
    initReveals(ctx); initHero(ctx); initBento(ctx); initSpot(ctx); initPin(ctx); initCats(ctx); initHover(ctx); initRows(ctx);
    fitAll();
  }
  function boot() {
    initProgress(); initCursor(); initAll(document);
    requestAnimationFrame(loop);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) {
    heroes = heroes.filter(function (h) { return document.body.contains(h.frame); });
    spots = spots.filter(function (s) { return document.body.contains(s.el); });
    pins = pins.filter(function (p) { return document.body.contains(p.el); });
    initProgress(); initAll(e.target);
  });
})();
